import React, { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import CompanionCreative from "./CompanionCreative";
import { clearSelectedCreatives } from "../../../actions/app/creatives";
import HelperTooltip from "../../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

export default forwardRef(({
  isClickEnabled,
  isDragDisabled,
  selectedCreatives,
  setSelectedCreatives,
  isThumbnailEnabled
}, ref) => {
  const [selectedIds, setSelectedIds] = React.useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();
  const placements = useSelector((state) => state.creatives.assignedPlacements);
  const creatives = useSelector((state) => state.creatives);

  const handleSelectCard = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const deselectCards = () => {
    setSelectedIds([]);
    // Clear both halves of the selection. selectCreative("") only blanked
    // selectedId and left the ids in selectedIds, so the next step rendered
    // highlighted cards with a disabled naming form.
    dispatch(clearSelectedCreatives());
  };

  // Companion creatives are optional — validation always passes
  useImperativeHandle(ref, () => ({
    validate() {
      return {
        hasErrors: false,
        message: ""
      };
    }
  }));

  return (
    <React.Fragment>
      <Typography variant="h6" className={classes.h6}>
        Add companion creatives (optional)
        <HelperTooltip tooltipText="Companion creatives are image or HTML5 assets displayed alongside the media player. They are delivered in the same VAST tag as your serving files." />
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <HorizontalAssetList
            selectedIds={selectedIds}
            handleSelectCard={handleSelectCard}
            isClickEnabled={isClickEnabled}
            isDragDisabled={isDragDisabled}
            isThumbnailEnabled={isThumbnailEnabled}
            isWeightEnabled={false}
            filterFn={(c) => c.file && c.file.type && (c.file.type.startsWith("audio/") || c.file.type.startsWith("video/"))}
          />
        </Grid>
        <Grid
          item
          xs={6}
          container
          direction="row"
          justify="space-around"
          alignItems="flex-start"
        >
          <CompanionCreative
            selectedIds={selectedIds}
            deselectCards={deselectCards}
            selectedCreatives={selectedCreatives}
            setSelectedCreatives={setSelectedCreatives}
            placements={placements}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
});
